<template>
    <div class="markets-wrapper">
      <app-header></app-header>
      <app-building v-if="this.$route.params.page === 'building-and-architecture'"></app-building>
      <app-transportation v-if="this.$route.params.page === 'transportation'"></app-transportation>
      <app-packaging v-if="this.$route.params.page === 'packaging'"></app-packaging>
      <app-distribution v-if="this.$route.params.page === 'distribution'"></app-distribution>
      <app-automotive v-if="this.$route.params.page === 'automotive'"></app-automotive>
    </div>
</template>

<script>
import Header from "./markets/Header";
import Building from "./markets/Building";
import Transportation from "./markets/Transportation";
import Packaging from "./markets/Packaging";
import Distribution from "./markets/Distribution";
import Automotive from "./markets/Automotive";
export default {
  components: {
    appHeader: Header,
    appBuilding: Building,
    appTransportation: Transportation,
    appPackaging: Packaging,
    appDistribution: Distribution,
    appAutomotive: Automotive
  },
  watch: {
    $route(to, from) {
//      this.isPageExisting();
    }
  },
  methods: {
    isPageExisting() {
      switch(this.$route.params.page){
        case('packaging'): 
          break
        default:
          this.$router.replace('../404')
      }
    }
  },
  mounted() {
//    this.isPageExisting();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Markets.vue